import { FormInputText } from "@imminently/react/ui/forms";
import { Control } from "react-hook-form";

import { css } from "@/theme";

const styles = {
  notes: css`
    .MuiInputBase-multiline {
      padding-top: 14px;
      padding-bottom: 14px;
    }

    textarea {
      resize: vertical;
    }
  `,
};

type MultilineTextInputProps = {
  control: Control<any, any>;
  field: string;
  label: string;
  required?: boolean;
  rows?: number;
};

const MultilineTextInput = (props: MultilineTextInputProps) => {
  const { control, field, label, required = false, rows } = props;

  return (
    <FormInputText
      css={styles.notes}
      required={required}
      name={field}
      label={label}
      control={control}
      autoFocus
      multiline={rows !== undefined && rows > 1}
      minRows={rows}
      size="medium"
    />
  );
};

export default MultilineTextInput;
